import gql from "graphql-tag"
import SessionFragment from "graphql/Streaming/Session/fragment/SessionFragment"

export default gql`

  ${SessionFragment}

  fragment MediaFragment on Media {
    id
    duration
    Version {
      id
      language
      role
      codec
      width
      height
      isHdr
      audioLanguages
      priority
    }
    Subtitle {
      id
      language
      offset
    }
    Session {
      ...SessionFragment
    }
  }
`
